import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
    selector: "project-title",
    imports: [CommonModule],
    templateUrl: "./project-title.component.html",
    styleUrls: ["./project-title.component.scss"],
})
export class ProjectTitleComponent {
    @Input() projectName: string;
    @Input() projectNumber: string;

    @Input() nameLength: number = null;
    @Input() small: boolean = false;

    constructor() {}
}
